import { FieldValueChangedArgs } from '@app/layout/field-value-changed-args';
import { LayoutService } from '@app/layout/layout.service';
import { ScheduleSuggestionsComponent } from '@app/layout/record-page/custom-buttons/schedule-suggestions/schedule-suggestions.component';
import * as moment from 'moment';
import { throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';
import * as g from 'src/app/globals';

const maxRetries = 2;
const delayMs = 1000;

export class DeliverScheduleUtil {
  deliverScheduledIsOpened: boolean[] = [];

  constructor(
    private layoutService: LayoutService,
    //private messageService: NzMessageService,
    //private modal: NzModalService,
    private listenToEvent: boolean = true,
  ) {
    if (!listenToEvent) {
      return;
    }
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      if (args.recordProperty === undefined) return;
      try {
        let additionalIdentifier = '';
        if (args.sectionTagName === 'Document_Lines') {
          const documentsSection = args.recordModel.Categories.find(
            (x) => x.Id === 'Documents',
          );

          const docTypeProp = documentsSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'DocType',
          );

          if (docTypeProp != null && docTypeProp !== undefined) {
            if (docTypeProp.ValueAsObject === 'dDocument_Service') {
              additionalIdentifier = 'services';
            } else {
              additionalIdentifier = 'items';
            }
          }
        }
        const section = args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === args.sectionTagName &&
            (additionalIdentifier === '' ||
              (additionalIdentifier !== '' &&
                x.AdditionalIdentifier === additionalIdentifier)),
        );
        let field = section.Fields.find(
          (f) => f.Id == args.recordProperty.FieldId,
        );

        if (
          field !== undefined &&
          field.AdditionalInformationParsed.AffectFormMode
        ) {
          this.layoutService.recordModelChanged = true;
        }
        this.oDeliverSchedule(args);
      } catch (e) {
        console.error(
          'An error occurred while trying to execute oDocuments',
          args,
          e,
        );
      }
    });
  }

  oDeliverSchedule(args: FieldValueChangedArgs) {
    if (args.recordProperty.Name === 'Quantity') {
      this.GetDeliveryScheduleSuggestion(args);
      if (
        g.autoDisplayDeliverSchedule ||
        g.autoDisplayDeliverScheduleForQuantity
      ) {
        setTimeout(() => {
          this.DisplayDeliverScheduleDrawer(args);
        }, 2000);
      }
    } else if (args.recordProperty.Name === 'ItemCode') {
      this.GetDeliveryScheduleSuggestion(args);
      if (
        g.autoDisplayDeliverSchedule ||
        g.autoDisplayDeliverScheduleForQuantity
      ) {
        setTimeout(() => {
          this.DisplayDeliverScheduleDrawer(args);
        }, 2000);
      }
    } else if (args.recordProperty.Name === 'TreeType') {
      this.GetDeliveryScheduleSuggestion(args);
      if (
        g.autoDisplayDeliverSchedule ||
        g.autoDisplayDeliverScheduleForQuantity
      ) {
        setTimeout(() => {
          this.DisplayDeliverScheduleDrawer(args);
        }, 2000);
      }
    } else if (
      args.recordProperty.Name === 'OnHand' ||
      (g.triggerDeliverScheduleForShipDate &&
        args.recordProperty.Name === 'ShipDate' &&
        (args.internalTrigger === undefined ||
          (args.internalTrigger !== undefined &&
            args.internalTrigger === false)))
    ) {
      this.GetDeliveryScheduleSuggestion(args);
      if (
        g.autoDisplayDeliverSchedule ||
        (args.recordProperty.Name === 'ShipDate' &&
          g.autoDisplayDeliverScheduleForShipDate) ||
        (args.recordProperty.Name === 'OnHand' &&
          g.autoDisplayDeliverScheduleForOnHand)
      ) {
        setTimeout(() => {
          this.DisplayDeliverScheduleDrawer(args);
        }, 2000);
      }
    }
  }

  DisplayDeliverScheduleDrawer(
    args: FieldValueChangedArgs,
    ignoreCondition: boolean = false,
  ) {
    const documents = this;
    /*let recordLine = args.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find(
        (l) =>
          l.Properties.find((p) => p.Name === 'LineNum').ValueAsObject ===
          args.line
      );
      if (recordLine === undefined) {
        recordLine = args.recordModel.Categories.find(
          (c) => c.Id === 'Document_Lines'
        ).Lines.find((l) => l.Id === args.line);
      }*/
    if (
      args.recordModel.Categories.find((c) => c.Id === 'Document_Lines') ==
        null ||
      args.recordModel.Categories.find((c) => c.Id === 'Document_Lines') ===
        undefined
    ) {
      return;
    }
    let recordLine = args.recordModel.Categories.find(
      (c) => c.Id === 'Document_Lines',
    ).Lines.find((l) => l.Id === args.line);

    let itemCode = recordLine.Properties.find(
      (p) => p.Name === 'ItemCode',
    ).ValueAsObject;

    console.log(documents.deliverScheduledIsOpened);

    if (documents.deliverScheduledIsOpened[itemCode]) {
      return;
    }

    if (recordLine == null || recordLine === undefined) {
      return;
    }

    let treeTypeProp = recordLine.Properties.find((p) => p.Name === 'TreeType');
    let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

    const qty = Number(
      recordLine.Properties.find((prop) => prop.Name === 'Quantity')
        .ValueAsObject,
    );
    const onHand = Number(
      recordLine.Properties.find((prop) => prop.Name === 'OnHand')
        ?.ValueAsObject,
    );

    if (
      !ignoreCondition &&
      (args.recordProperty.Name === 'Quantity' ||
        args.recordProperty.Name === 'OnHand') &&
      (qty <= onHand || treeType === 'I' || treeType === 'iIngredient')
    ) {
      return;
    }

    let scheduleSuggestionsStr = recordLine.Properties.find(
      (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE',
    )?.ValueAsObject;

    let scheduleSuggestions: any;
    try {
      scheduleSuggestions = JSON.parse(scheduleSuggestionsStr);
    } catch {
      scheduleSuggestions = {};
    }

    const lineShipDate = recordLine.Properties.find(
      (p) => p.Name === 'ShipDate',
    )?.ValueAsObject;

    let shipDateFromDeliverSchedule = new Date();

    try {
      scheduleSuggestions.forEach(function (schedule) {
        var scheduleDate = schedule.DeliveryDate;
        shipDateFromDeliverSchedule = scheduleDate;
        return;
      });
    } catch {
      return;
    }

    if (
      !ignoreCondition &&
      args.recordProperty.Name === 'ShipDate' &&
      (lineShipDate == shipDateFromDeliverSchedule ||
        treeType === 'I' ||
        treeType === 'iIngredient')
    ) {
      return;
    }

    if (scheduleSuggestions.length < 2) {
      return;
    }

    const drawerRef = this.layoutService.drawerService.create({
      nzContent: ScheduleSuggestionsComponent,
      nzWrapClassName: 'drawer-size-3x',
      nzContentParams: {
        scheduleSuggestions: scheduleSuggestions,
        recordLine: recordLine,
        recordModel: args.recordModel,
        line: args.line,
      },
      nzTitle: 'Delivery Schedule',
    });
    documents.deliverScheduledIsOpened[itemCode] = true;

    drawerRef.afterOpen.subscribe(() => {
      const instance = drawerRef.getContentComponent();
      if (instance && instance.okButtonClicked) {
        instance.okButtonClicked.subscribe(() => {
          const instance1 = drawerRef.getContentComponent();
          console.log('Filter button clicked:', instance1.scheduleSuggestions);

          recordLine.Properties.find(
            (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE',
          ).ValueAsObject = JSON.stringify(instance1.scheduleSuggestions);

          const lineShipDate = recordLine.Properties.find(
            (p) => p.Name === 'ShipDate',
          );
          if (lineShipDate != null && lineShipDate !== undefined) {
            this.layoutService.triggerFieldValueChanged({
              recordModel: args.recordModel,
              recordProperty: lineShipDate,
              formId: '',
              line: args.line,
              sectionTagName: args.sectionTagName,
              moduleStructure: args.moduleStructure,
              internalTrigger: true,
            });
          }

          drawerRef.close();
          documents.deliverScheduledIsOpened[itemCode] = false;

          this.layoutService.submitDeliverSchedule.emit(args.line);
        });
      }
      if (instance && instance.cancelButtonClicked) {
        instance.cancelButtonClicked.subscribe(() => {
          documents.deliverScheduledIsOpened[itemCode] = false;
          drawerRef.close();
        });
      }
    });
  }

  GetDeliveryScheduleSuggestion(e: FieldValueChangedArgs) {
    const documents = this;
    let recordModel = e.recordModel;
    let recordProperty = e.recordProperty;

    //console.log('recordProperty.Name>>',recordProperty.Name);

    let lineCat = recordModel.Categories.find((x) => x.Id === 'Document_Lines');
    let headerCat = recordModel.Categories.find((x) => x.Id === 'Documents');
    if (lineCat == null || lineCat === undefined) {
      return;
    }

    let recordLineOfField = lineCat.Lines.find((l) => l.Id === e.line);

    let docEntryProp = lineCat.Lines[0].Properties.find(
      (p) => p.Name === 'DocEntry',
    );

    let lineNumProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'LineNum',
    );

    let itemCodeProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'ItemCode',
    );
    let itemCode = itemCodeProp ? itemCodeProp.ValueAsObject : null;
    if (itemCode == null || itemCode === undefined || itemCode === '') {
      return;
    }

    // Get Quantity from the current line
    let quantityProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'Quantity',
    );
    let quantity = quantityProp ? quantityProp.ValueAsObject : 0;

    // Get the UDF for delivery schedule
    let deliverProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE',
    );

    if(deliverProp == null) {
      return;
    }

    let treeTypeProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'TreeType',
    );
    let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

    let InvntItemProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'InvntItem',
    );
    let InvntItem = InvntItemProp ? InvntItemProp.ValueAsObject : null;

    //debugger;
    // Get Requested Delivery Date from the current line
    let shipDateProp = recordLineOfField.Properties.find(
      (p) => p.Name === 'ShipDate' || p.Name === 'DeliveryDate',
    );

    /*let shipDatePropHeader = recordLineOfField.Properties.find(
        (p) => p.Name === 'ShipDate' || p.Name === 'DeliveryDate'
      );*/

    let headerDueDate = headerCat.Lines[0].Properties.find(
      (p) => p.Name === 'DocDueDate',
    ).ValueAsObject;

    let requestedDeliveryDate = shipDateProp
      ? shipDateProp.ValueAsObject
      : null;
    if (requestedDeliveryDate == '' || undefined) {
      requestedDeliveryDate = headerDueDate;
    }

    if (
      recordProperty.Name === 'Quantity' &&
      new Date(headerDueDate) < new Date()
    ) {
      requestedDeliveryDate = new Date();
    } else if (
      recordProperty.Name === 'Quantity' &&
      new Date(headerDueDate) >= new Date()
    ) {
      requestedDeliveryDate = new Date(headerDueDate);
    }

    //console.log(treeType);

    if (treeType == 'I' || treeType == 'iIngredient') {
      deliverProp.ValueAsObject = '';
      return;
    }
    if (!(treeType == 'S' || treeType == 'iSalesTree') && InvntItem == 'N') {
      deliverProp.ValueAsObject = '';
      return;
    }

    // Build additionalCommittedQuantities from other lines (excluding current line)
    let additionalCommittedQuantities = [];
    let lines = lineCat.Lines;
    let quantities = 0;

    lines.forEach(function (line) {
      if (line.Id !== e.line) {
        let lineItemCodeProp = line.Properties.find(
          (p) => p.Name === 'ItemCode',
        );
        let lineItemCode = lineItemCodeProp
          ? lineItemCodeProp.ValueAsObject
          : null;

        // Get U_ITM_DELIVER_SCHEDULE from the line
        let lineDeliverProp = line.Properties.find(
          (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE',
        );
        let lineDeliverScheduleJson = lineDeliverProp
          ? lineDeliverProp.ValueAsObject
          : null;

        if (lineItemCode && lineDeliverScheduleJson) {
          try {
            // Parse the JSON from U_ITM_DELIVER_SCHEDULE
            let lineDeliverSchedule = JSON.parse(lineDeliverScheduleJson);

            // lineDeliverSchedule is expected to be an array of schedule suggestions
            lineDeliverSchedule.forEach(function (schedule) {
              // Extract Quantity and Date from the schedule
              let scheduleQuantity = schedule.Quantity;
              let scheduleDate = schedule.DeliveryDate;

              if (schedule.ComponentAllocations) {
                schedule.ComponentAllocations.forEach(
                  function (componentAllocations) {
                    additionalCommittedQuantities.push({
                      ItemCode: componentAllocations.ComponentCode,
                      Quantity: componentAllocations.QuantityAllocated,
                      Date: scheduleDate,
                    });
                  },
                );
              }

              additionalCommittedQuantities.push({
                ItemCode: lineItemCode,
                Quantity: scheduleQuantity,
                Date: scheduleDate,
              });
            });
          } catch (ex) {
            console.error('Error parsing U_ITM_DELIVER_SCHEDULE JSON:', ex);
          }
        }
      }
    });

    // Exclude current line quantities
    let excludedCommittedQuantities = [];

    if (itemCode && quantity > 0 && deliverProp && deliverProp.ValueAsObject) {
      try {
        // Parse the JSON from U_ITM_DELIVER_SCHEDULE of the current line
        let deliverSchedule = JSON.parse(deliverProp.ValueAsObject);

        deliverSchedule.forEach(function (schedule) {
          let scheduleQuantity = schedule.Quantity;
          let scheduleDate = schedule.DeliveryDate;
          //shipDateProp.ValueAsObject = scheduleDate;
          quantities += schedule.Quantity;

          if (scheduleQuantity != 0 && schedule.ComponentAllocations != null) {
            schedule.ComponentAllocations.forEach(
              function (componentAllocations) {
                componentAllocations.POAllocations.forEach(
                  function (poAllocations) {
                    excludedCommittedQuantities.push({
                      ItemCode: componentAllocations.ComponentCode,
                      Quantity: poAllocations.QuantityAllocated,
                      Date: scheduleDate,
                    });
                  },
                );
              },
            );

            excludedCommittedQuantities.push({
              ItemCode: itemCode,
              Quantity: scheduleQuantity,
              Date: scheduleDate,
            });
          }
        });
      } catch (ex) {
        console.error(
          'Error parsing U_ITM_DELIVER_SCHEDULE JSON for current line:',
          ex,
        );
      }
    }

    if (quantities === quantity && e.recordProperty.Name !== 'ShipDate') {
      return;
    }

    // Build the payload
    let payload = {
      ItemCode: itemCode,
      Quantity: quantity,
      LineNum: lineNumProp.ValueAsObject,
      DocEntry: docEntryProp.ValueAsObject,
      RequestedDeliveryDate: (function () {
        let date = new Date(requestedDeliveryDate);
        // Get the date components (Year, Month, Day)
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so adding 1
        let day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      })(),
      AdditionalCommittedQuantities: additionalCommittedQuantities,
      ExcludedCommittedQuantities: excludedCommittedQuantities,
    };

    let jsonToPush = JSON.stringify(payload);
    let actionCode = 'GetDeliveryScheduleSuggestion';

    // Make the AJAX request to the backend
    this.layoutService
      .pushDataToBackend(jsonToPush, actionCode, jsonToPush)
      .pipe(
        retryWhen((errors) =>
          errors.pipe(
            mergeMap((error, index) => {
              const retryAttempt = index + 1;

              if (retryAttempt > maxRetries) {
                return throwError(error); // stop retrying
              }

              console.log(`Retry attempt ${retryAttempt}`);
              return timer(delayMs); // wait 1s before retry
            }),
          ),
        ),
      )
      .subscribe({
        //console.log('data', data);
        next: (data: any) => {
          if (!data.Has_Error && data.Resault_Value) {
            deliverProp.ValueAsObject = data.Resault_Value;

            var deliverSchedule = JSON.parse(deliverProp.ValueAsObject);
            deliverSchedule.forEach(function (schedule) {
              var scheduleDate = schedule.DeliveryDate;
              if (
                moment(shipDateProp.ValueAsObject).format('YYYY-MM-DD') !==
                  moment(scheduleDate).format('YYYY-MM-DD') &&
                e.recordProperty.Name === 'ShipDate'
              ) {
                if (
                  g.autoDisplayDeliverSchedule ||
                  g.autoDisplayDeliverScheduleForShipDate
                ) {
                  documents.DisplayDeliverScheduleDrawer(e, true);
                }
              }
              shipDateProp.ValueAsObject = scheduleDate;

              documents.layoutService.triggerBomParentFieldValueChanged({
                recordModel: e.recordModel,
                recordProperty: shipDateProp,
                formId: '',
                line: e.line,
                sectionTagName: e.sectionTagName,
                moduleStructure: e.moduleStructure,
              });

              documents.layoutService.triggerFieldValueChanged({
                recordModel: e.recordModel,
                recordProperty: deliverProp,
                formId: '',
                line: e.line,
                sectionTagName: e.sectionTagName,
                moduleStructure: e.moduleStructure,
              });

              if (
                recordLineOfField.Properties.find(
                  (p) => p.Name === 'U_ITM_CHANGED',
                ) != null &&
                recordLineOfField.Properties.find(
                  (p) => p.Name === 'U_ITM_CHANGED',
                ) !== undefined
              ) {
                recordLineOfField.Properties.find(
                  (p) => p.Name === 'U_ITM_CHANGED',
                ).Value = 'Y';
                recordLineOfField.Properties.find(
                  (p) => p.Name === 'U_ITM_CHANGED',
                ).ValueAsObject = 'Y';
              }

              return;
            });
          } else {
            if (!deliverProp && deliverProp !== undefined) {
              deliverProp.ValueAsObject = '';
            }
          }
        },
        error: (err) => {
          console.error('Failed after 2 retries:', err);
        },
      });
  }
}
